<template>
  <div class="home">
    <h2>Installations</h2>

    <!--<b-button @click="raisePopup({ target: $event.target })" variant="primary">-->
    <!--Add new-->
    <!--</b-button>-->

    <!-- Info modal -->
    <b-modal
      id="installationsModal"
      v-bind:title="this.isEdit ? 'Edit installation' : 'New installation'"
      @ok="installationFormSubmit"
    >
      <b-form>
        <input id="newInstallationInput0" type="hidden" v-model="form.id" />
        <b-form-group
          id="newInstallationInputGroup1"
          label="Installation GUID:"
          label-for="newInstallationInput1"
        >
          <b-form-input
            id="newInstallationInput1"
            type="text"
            v-model="form.name"
            placeholder="Enter installation GUID"
          />
        </b-form-group>

        <b-form-group
          id="newInstallationInputGroup2"
          label="User ID:"
          label-for="newInstallationInput2"
        >
          <b-form-input
            id="newInstallationInput2"
            type="text"
            v-model="form.userId"
            placeholder="Enter User ID"
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <b-container fluid>
      <!-- User Interface controls -->
      <!--<b-row>-->
      <!--<b-col md="12" class="my-1">-->
      <!--<b-form-group label-cols-sm="1" label="Filter" class="mb-0">-->
      <!--<b-input-group>-->
      <!--<b-form-input v-model="filter" placeholder="Type to Search" />-->
      <!--<b-input-group-append>-->
      <!--<b-button :disabled="!filter" @click="filter = ''"-->
      <!--&gt;Clear</b-button-->
      <!--&gt;-->
      <!--</b-input-group-append>-->
      <!--</b-input-group>-->
      <!--</b-form-group>-->
      <!--</b-col> </b-row>-->
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        ref="installationsTable"
        class="installationsTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                installation: row.item
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              deleteInstallation({
                target: $event.target,
                installation: row.item
              })
            "
          >
            X
          </b-button>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

const originalForm = {
  id: null,
  name: null,
  userId: null,
  whilelabelId: null
};

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      form: {
        ...originalForm
      },
      isEdit: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'name',
          label: 'GUID',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'userId',
          label: 'User ID',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'whitelabel.name',
          label: 'Whitelabel',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.installations.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, installation = null }) {
      this.isEdit = isEdit;
      if (installation && isEdit) {
        this.form = Object.keys(originalForm).reduce(
          (acc, current) =>
            installation[current]
              ? {
                  ...acc,
                  [current]: String(installation[current])
                }
              : acc,
          {}
        );
      } else {
        this.installationFormReset();
      }
      this.$root.$emit('bv::show::modal', 'installationsModal', target);
    },
    deleteInstallation({ installation = null }) {
      if (!installation) {
        return;
      }
      const promise = this.$store.dispatch(
        'deleteInstallation',
        installation.id
      );

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.installationsTable.refresh();
      });
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const promise = this.$store.dispatch('getInstallations', ctx);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        return this.$store.state.installations.rows || [];
      });
    },
    installationFormReset() {
      this.form = { ...originalForm };
    },
    async installationFormSubmit(event) {
      if (!this.isEdit) {
        await this.$store.dispatch('addInstallation', {
          installation: this.form,
          event
        });
      } else {
        await this.$store.dispatch('editInstallation', {
          installation: this.form,
          event
        });
      }

      this.installationFormReset();
      this.$refs.installationsTable.refresh();
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.installationsTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
